import {
    GameInfoContent,
    GameInfoHeader,
    GameInfoImageWrapper,
    GameInfoWrapper,
    StyledTextItem,
  } from './styles';
  import { Box, Chip, Typography } from '@mui/material';
  import React from 'react';
  import { useTranslation } from 'next-i18next';
  import ArrowRightIcon from '@mui/icons-material/ArrowRight';
  import Image from 'next/image';
  import useTheme from '@/theme/useTheme';
  import { StyledTokenIcon } from '@/components/ui/common/TokenIcon';
  
  interface GameInfoProps {
    title: string;
    gameId: string;
    children?: React.ReactNode;
    open?: boolean;
  }
  
  const TextReplaceUSDT = ({ text }) => {
    const { t } = useTranslation();
    const list = text.split('USDT');
    return list.map((item, index) => {
      const isLast = index === list.length - 1;
      return (
        <>
          <span key={index}>{t(item)}</span>
          {!isLast && (
            <StyledTokenIcon
              style={{
                marginLeft: '-1px',
                verticalAlign: '-3px',
              }}
            />
          )}
        </>
      );
    });
  };
  export const useGameInfo = (info) => {
    const { t } = useTranslation();
    const { theme } = useTheme();
    const ComMap = {
      banner: (item, index) => {
        const { img, tag, desc } = item;
        const descriptions = Array.isArray(desc) ? desc : [desc];
        const lastIndex = descriptions.length - 1;
        return (
          <Box sx={{ display: 'flex', mb: 2 }} key={index}>
            <GameInfoImageWrapper
              sx={{
                minWidth: img.width,
                height: img.height,
                mr: 2,
              }}
            >
              <Image src={img.src} fill alt={img.alt} />
            </GameInfoImageWrapper>
  
            <Box>
              {/*<Chip*/}
              {/*  sx={{*/}
              {/*    mb: 1,*/}
              {/*    fontFamily: 'Readex Pro',*/}
              {/*  }}*/}
              {/*  label={t(tag)}*/}
              {/*></Chip>*/}
              {descriptions.map((d, i) => (
                <Typography
                  fontWeight="400"
                  fontSize={'14px'}
                  sx={{
                    mb: i === lastIndex ? 0 : 1,
                  }}
                  key={d}
                >
                  {t(d)}
                </Typography>
              ))}
            </Box>
          </Box>
        );
      },
      list: (item, index) => {
        const { title, list } = item;
        return (
          <Box sx={{ mb: 2 }} key={index}>
            <Typography
              fontFamily={'Readex Pro'}
              variant={'body1'}
              sx={{ mb: 1, fontWeight: 700 }}
            >
              {t(title)}
            </Typography>
            <Box
              style={{
                // paddingLeft: '16px',
                fontSize: '12px',
                lineHeight: '1.4',
              }}
            >
              {list.map((ele, i) => {
                if (typeof ele === 'string') {
                  return (
                    <Box key={i}>
                      <Typography
                        sx={{
                          color: (theme) => theme.palette.text.help,
                        }}
                        component={'span'}
                      >
                        {i + 1 + '. '}
                      </Typography>
                      <TextReplaceUSDT text={ele} />
                    </Box>
                  );
                } else {
                  return ele;
                }
              })}
            </Box>
          </Box>
        );
      },
      image: (img, index) => {
        return (
          <GameInfoImageWrapper
            key={index}
            sx={{
              minWidth: img.width,
              width: img.width,
              height: img.height,
              mb: 2,
              mt: 2,
              // [theme.breakpoints.down('sm')]: {
              //   width: '100%',
              //   minWidth: '100%',
              // },
            }}
          >
            <Image src={img.src} fill alt={img.alt} />
          </GameInfoImageWrapper>
        );
      },
      text: (text, index) => {
        const { content, no } = text;
        return (
          <StyledTextItem key={index}>
            <span>{no + '. '}</span>
            <Typography key={index} variant="body2">
              {t(content)}
            </Typography>
          </StyledTextItem>
        );
      },
      title: (item, index) => {
        return (
          <Typography key={index} variant="h6" sx={{ mb: 1 }}>
            {t(item.content)}
          </Typography>
        );
      },
      p: (item, index) => {
        return (
          <Typography key={index} variant="body2" sx={{ mb: 1 }}>
            <TextReplaceUSDT text={item.content} />
          </Typography>
        );
      },
    };
    return info.map((item, index) => {
      return ComMap[item.type](item, index);
    });
  };
  
  export default function GameInfo({ title, children, open }: GameInfoProps) {
    const [isOpen, setIsOpen] = React.useState(!!open);
    const toggle = () => {
      setIsOpen(!isOpen);
    };
    const { t } = useTranslation();
  
    return (
      <GameInfoWrapper>
        <GameInfoHeader onClick={toggle}>
          <Typography
            component="h5"
            fontFamily="Readex Pro"
            fontWeight="500"
            color={'#FFFFFF'}
            sx={{
              fontSize: '14px',
              fontFamily: 'Readex Pro',
            }}
          >
            {t('How To Play')}
            <Typography
              component={'span'}
              sx={{
                fontSize: '12px',
                border: (theme) => theme.palette.border.primary,
                borderRadius: '8px',
                padding: '2px 4px',
                ml: '10px',
              }}
            >
              {t('MoonClub Originals')}
            </Typography>
          </Typography>
          <ArrowRightIcon
            onClick={toggle}
            sx={{
              transition: 'all 0.3s ease',
              transform: isOpen ? 'rotate(-90deg)' : 'rotate(90deg)',
              cursor: 'pointer',
              color: (theme) => theme.palette.text.help,
            }}
          />
        </GameInfoHeader>
        {isOpen && <GameInfoContent>{children}</GameInfoContent>}
      </GameInfoWrapper>
    );
  }
  